import { useAuth0 } from "@auth0/auth0-react";
import styles from "./expenseCategoryCardMobile.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";

const ExpenseCategoryCardMobile = ({ item, setDeleteModalOpen, setSelectecId, setEditModalOpen, setEditUserData, openDropdownId, setOpenDropdownId }) => {
  const { user, isAuthenticated } = useAuth0();

  const handleToggle = (id) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  }

  return (<>
    <div className={`${styles.MaintenanceReqCard}`} onClick={(e) => {
      if (item?.is_primary) return;
      if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-category:update") > -1) {
        setEditModalOpen(true);
        setEditUserData(item);
      } else {
        return false;
      }
    }}    >
      {!item?.is_primary && isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("expense-category:update") > -1 || user["https://propertydek.com/permissions"].indexOf("expense-category:delete") > -1) && (<Dropdown className={`${styles.ActionLeaseBUSecSmall}`} show={openDropdownId === item.id} onToggle={() => handleToggle(item.id)} onClick={(e) => { e.stopPropagation(); }}>
        <Dropdown.Toggle className={`${styles.ActionsLeaseBUSmall} ActionsBU`} id="dropdown-basic">
          <MoreVertical />
        </Dropdown.Toggle>

        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-category:update") && <Dropdown.Item className={`${styles.EditActionsBUListItemSmall}`} onClick={(e) => { setEditModalOpen(true); setEditUserData(item); }}>
            <Edit /> Edit
          </Dropdown.Item>}
          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-category:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItemSmall} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
            <Trash2 /> Delete
          </Dropdown.Item>}
        </Dropdown.Menu>
      </Dropdown>)}
      <div className={`${styles.CardImgSec} Secondary`}>
        <img src="/static/img/category-income.svg" alt="" />
      </div>
      <div className={`${styles.MainReCardCon}`}>
        <div>
          <div className={`${styles.MainReCardIdStatus}`}>
            <p className={`${styles.Title}`}>{item?.title}</p>
          </div>
          <div className={`${styles.MainReCardIdStatusTwo}`}>
            <p className={`${styles.MainReID}`}>
              <span className={`${styles.StatusBadge}`} style={{ backgroundColor: item?.color }}>{item?.color}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </>);
};

export default ExpenseCategoryCardMobile;